import * as React from "react";
import { createContext, useContext } from "react";
import { InsightPage } from "@radarly/models/insight-pages/model";

const InsightPageContext = createContext<InsightPage>(null);

export function useCurrentInsightPage() {
  return useContext(InsightPageContext);
}

interface IProps {
  children: React.ReactNode;
  insightPage: InsightPage;
}

export const InsightPageProvider = ({ children, insightPage }: IProps) => {
  return (
    <InsightPageContext.Provider value={insightPage}>
      {children}
    </InsightPageContext.Provider>
  );
};
